"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatGPT = void 0;
var cash_dom_1 = __importDefault(require("cash-dom"));
var marked_1 = require("marked");
var input_output_helper_const_1 = require("../../const/input-output-helper.const");
var input_mapping_const_1 = require("../../const/input.mapping.const");
var css_injector_service_1 = require("../../services/css-injector.service");
var object_service_1 = require("../../services/object-service");
var settings_service_1 = require("../../services/settings.service");
var bot_choice_1 = require("./bot-choice");
var demo_bot_stylings_const_1 = require("./css/demo-bot-stylings.const");
var send_requests_1 = require("./services/send-requests");
/**
 * renders a complete widget with bot options etc
 */
var ChatGPT = /** @class */ (function () {
    function ChatGPT() {
        this.chatId = Math.round(Math.random() * 1000000000000000);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.freshConversation = true;
        this.botChoice = object_service_1.ObjectService.getInstance(bot_choice_1.BotChoice);
        this.firstContact = true;
    }
    ChatGPT.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chatGPTContainer, textarea, button, displayContentAboveTextarea, startTyping, stopTyping, sendRequest, performRequest;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        chatGPTContainer = (0, cash_dom_1.default)('#chatgpt');
                        if (!((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.chatgpt) === null || _b === void 0 ? void 0 : _b.botChoice)) return [3 /*break*/, 2];
                        chatGPTContainer.children().toggle();
                        return [4 /*yield*/, this.botChoice.loadModule(chatGPTContainer, function () {
                                chatGPTContainer.children().toggle();
                                performRequest({
                                    textInput: '',
                                });
                            })];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        (0, css_injector_service_1._InjectCss)('_DemoBotStylings', demo_bot_stylings_const_1._DemoBotStylings);
                        if (chatGPTContainer.length === 0) {
                            console.error('You have chatgpt widget includede but no form');
                            return [2 /*return*/];
                        }
                        chatGPTContainer.addClass('chatGPTContainer');
                        textarea = chatGPTContainer.find('textarea').css('width', '100%');
                        button = chatGPTContainer.find('.w-button');
                        displayContentAboveTextarea = function (content, className) {
                            var _a, _b;
                            var $contentSpan = (0, cash_dom_1.default)('<span></span>');
                            if (className === 'answer-c') {
                                $contentSpan.html(content);
                            }
                            else {
                                $contentSpan.text(content);
                            }
                            // $contentSpan.css({ 'white-space': 'pre-line' });
                            var $contentDiv = (0, cash_dom_1.default)('<div></div>')
                                .addClass('fittec-slide-in-left')
                                .addClass('response-content')
                                .addClass(className)
                                .append($contentSpan);
                            if (((_a = _this.botChoice) === null || _a === void 0 ? void 0 : _a.bot) && className === 'answer-c') {
                                var botImage = (0, cash_dom_1.default)('<img>"');
                                botImage.attr('src', _this.botChoice.bot.assetImage);
                                botImage.css({
                                    width: '35px',
                                    'border-radius': '50%',
                                    margin: '4px',
                                });
                                $contentDiv.prepend(botImage);
                            }
                            if (!((_b = _this.botChoice) === null || _b === void 0 ? void 0 : _b.bot) || className === 'question-c') {
                                var $hardcodedSpan = (0, cash_dom_1.default)('<span></span>').css('padding', '4px').css('font-size', '1.5rem');
                                $hardcodedSpan.text(className === 'answer-c' ? 'A' : 'Q');
                                $contentDiv.prepend($hardcodedSpan);
                            }
                            if (className === 'answer-c') {
                                var thumbUp = (0, cash_dom_1.default)('<img class="thumb" title="Good answer" src="' + _this.config.get.assetsUrl + '/thumb.svg"/>');
                                var thumbDown = (0, cash_dom_1.default)('<img class="thumb" title="Wrong or unhelpful answer" style="margin-top:15px;transform:rotate(180deg)" src="' +
                                    _this.config.get.assetsUrl +
                                    '/thumb.svg"/>');
                                thumbUp.on('click', function () {
                                    console.log('thumb up');
                                    sendRequest('good');
                                });
                                thumbDown.on('click', function () {
                                    console.log('thumb down');
                                    sendRequest('bad');
                                });
                                var thumbs = (0, cash_dom_1.default)('<div></div>').addClass('thumbs').append(thumbUp).append(thumbDown);
                                $contentDiv.append(thumbs);
                            }
                            textarea.before($contentDiv);
                        };
                        startTyping = function () {
                            var _a, _b, _c, _d;
                            var $contentSpan = (0, cash_dom_1.default)('<span></span>').text(((_c = (_b = (_a = _this.botChoice) === null || _a === void 0 ? void 0 : _a.bot) === null || _b === void 0 ? void 0 : _b.displayName) !== null && _c !== void 0 ? _c : 'Assistent') + ' tippt gerade');
                            var typewriter = (0, cash_dom_1.default)('<div class="snippet" data-title="dot-pulse"><div class="stage"><div class="dot-pulse"></div></div></div>');
                            $contentSpan.append(typewriter);
                            var $contentDiv = (0, cash_dom_1.default)('<div></div>')
                                .addClass('response-content')
                                .addClass('fittec-slide-in-left')
                                .addClass('assistant-typing')
                                .append($contentSpan);
                            if ((_d = _this.botChoice) === null || _d === void 0 ? void 0 : _d.bot) {
                                var botImage = (0, cash_dom_1.default)('<img>');
                                botImage.attr('src', _this.botChoice.bot.assetImage);
                                botImage.css({
                                    width: '35px',
                                    'border-radius': '50%',
                                    margin: '4px',
                                });
                                $contentSpan.prepend(botImage);
                            }
                            $contentDiv.prepend();
                            textarea.before($contentDiv);
                        };
                        stopTyping = function () {
                            (0, cash_dom_1.default)('.assistant-typing').remove();
                        };
                        sendRequest = function (type) {
                            var data = {};
                            if (type === 'simple') {
                                data.textInput = textarea.attr('value');
                                textarea.val('');
                                displayContentAboveTextarea(data.textInput, 'question-c');
                            }
                            else {
                                data.textInput = _this.lastRequest + '. Der Kunde war mit deiner Antwort nicht zufrieden. Streng dich bitte an.';
                                if (type === 'bad') {
                                    //TBD
                                }
                                else if (type === 'good') {
                                    //TBD
                                }
                            }
                            if (_this.freshConversation === true) {
                                //TBD
                            }
                            performRequest(data);
                        };
                        performRequest = function (data) {
                            setTimeout(function () {
                                startTyping();
                            }, 1000);
                            if ((0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId)) {
                                data['studioId'] = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                            }
                            _this.lastRequest = data.textInput;
                            data.conversationId = String(_this.chatId);
                            (0, send_requests_1._PerformRequest)(_this.config.get.tenantKey, data.conversationId, data, _this.firstContact)
                                .then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = displayContentAboveTextarea;
                                            return [4 /*yield*/, (0, marked_1.marked)(data.response)];
                                        case 1:
                                            _a.apply(void 0, [_b.sent(), 'answer-c']);
                                            this.freshConversation = false;
                                            stopTyping();
                                            this.firstContact = false;
                                            return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function (error) {
                                // Handle error response
                                console.error('Error:', error);
                                stopTyping();
                                _this.firstContact = false;
                            });
                        };
                        // When "Enter" key is pressed inside textarea
                        textarea.on('keydown', function (e) {
                            if (e.keyCode == 13 && !e.shiftKey) {
                                // Check for "Enter" key and make sure "Shift" key isn't pressed
                                e.preventDefault(); // Prevents new line from being added
                                e.stopImmediatePropagation(); // Prevents new line from being added
                                sendRequest('simple');
                            }
                        });
                        // When button is clicked
                        button.on('click', function () {
                            sendRequest('simple');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return ChatGPT;
}());
exports.ChatGPT = ChatGPT;
